import api from './api'
export default {
    upload (parms) {
      return api.post('files/upload', parms, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    },
    getFiles(parms) {
      // return api.get('files?type='+parms.type+'&id='+parms.id)
      return api.get('files',{
        params: parms
        })
    },
    pin(parms) {
      return api.get('files/pin',{params:parms})
    },
    search(params) {
      return api.post('files/search',params);
    },
    uploadProofs(parms){
      return api.post('files/upload/proofs', parms, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    },
    uploadRequiredDoc(parms){
      return api.post('files/upload/company_docs', parms, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    }
    
  }